export default __webpack_public_path__ + "static/gardian_watchmen.8fd8cf48db0cab9339037b6cfecb29e1.png";